import { isOnlyLocalhost, isProxyRequired } from './system';

// プロキシ経由で接続する場合は、URLホスト名を置き換える。
// * LGWANまたはAWS Direct Connectの場合、
// * プロキシ経由で接続するには、URL Hostname を置き換える必要があります。
// * useProxy パラメータを true に設定することで、必要がない場合でもプロキシ経由で接続することができます。
export const replaceLocationHost = (url: string, useProxy = false): string => {
  const newUrl = new URL(url);
  if (isProxyRequired() || useProxy) {
    if (isOnlyLocalhost()) {
      // In the case of localhost, localhost:80 to connect with Reverse Proxy.
      newUrl.host = 'localhost:80';
    } else {
      // In the case of LGWAN, the hostname is replaced with the current location.
      newUrl.host = location.host;
    }
  }

  return newUrl.href;
};
